import React, { Component } from "react";
import { Modal, Input } from "antd";
import axios from "../../../../services/axios";
import Axios from "axios";
import { errorMessage } from "../../../Utils";

const { TextArea } = Input;

class ModalRejectApproval extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmLoading: false,
      rejectedNotes: null,
    };
  }

  handleSubmit = async () => {
    const { rejectedNotes } = this.state;
    const { id, actionModal, type, payload } = this.props;
    this.setState({ isLoading: true });
    let url = type === "GM" ? "general-manager-approval" : "boh-reject";
    let payloads = {
      rejectedNotes,
      isApproved: false,
    };
    // if (rejectedNotes) {
    await axios
      .patch(`/car-sales/${id}/${url}`, payloads)
      .then((result) => {
        // message.success(`Berhasil reject approval`);
        actionModal();
        // this.props.history.push(`/home/e-approval/selling-system`);
      })
      .catch((err) => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        }
      });
    // }
    this.setState({ isLoading: false });
  };

  render() {
    const { confirmLoading, rejectedNotes } = this.state;
    const { toggleShowModal, showModal, type, actionModal } = this.props;
    return (
      <Modal
        title={`${type === "cancel" ? "Cancel" : "Tolak"} Pengajuan Diskon`}
        visible={showModal}
        confirmLoading={confirmLoading}
        okText={"Simpan"}
        onOk={() =>
          type === "cancel"
            ? actionModal("cancel", rejectedNotes)
            : this.handleSubmit()
        }
        onCancel={() => toggleShowModal(false)}
        width={450}>
        <p>Masukkan alasan penolakan anda pada pengajuan ini</p>
        <p style={{ margin: 0 }}>Alasan Penolakan</p>
        <TextArea
          rows={4}
          placeholder={"Masukkan alasan penolakan anda"}
          onChange={(event) =>
            this.setState({ rejectedNotes: event.target.value })
          }
        />
      </Modal>
    );
  }
}

export default ModalRejectApproval;



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/Modal/ModalRejectApproval.js